import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XIcon } from 'lucide-react';

interface SignInPromptModalProps {
  onClose: () => void;
}

const SignInPromptModal: React.FC<SignInPromptModalProps> = ({ onClose }) => {
  const navigate = useNavigate();

  const handleNavigate = (mode: 'signup' | 'login') => {
    navigate(`/auth?mode=${mode}`);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <XIcon className="w-5 h-5" />
        </button>

        <h2 className="text-xl font-bold text-center text-textPrimary mb-4">Sign In Required</h2>
        <p className="text-sm text-center text-textSecondary mb-6">
          To support, oppose, or vote on a campaign, please sign up or log in to your Ballotr account.
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => handleNavigate('signup')}
            className="bg-ballotr-blue text-white py-2 rounded-md font-semibold hover:bg-ballotr-blue-light transition"
          >
            Sign Up
          </button>
          <button
            onClick={() => handleNavigate('login')}
            className="border border-gray-300 text-gray-700 py-2 rounded-md font-medium hover:bg-gray-100 transition"
          >
            Log In
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignInPromptModal;
